export default "__VITE_ASSET__DQEcXL7O__"